import PropTypes from 'prop-types';
import clsx from 'clsx';
import classes from './Menu.module.css';

const MenuList = ({ children, className }) => {
    return <div className={clsx(classes.menuList, className)}>{children}</div>;
};

MenuList.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node,
};

export default MenuList;
